/**
 * tolling-api v2
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ActivityRefundResponseDto {
    type?: ActivityRefundResponseDto.TypeEnum;
    name?: string;
    amount?: number;
}
export namespace ActivityRefundResponseDto {
    export const TypeEnum = {
        UserSegment: 'USER_SEGMENT',
        LoyaltyProgram: 'LOYALTY_PROGRAM',
        Compensation: 'COMPENSATION',
    } as const;
    export type TypeEnum = (typeof TypeEnum)[keyof typeof TypeEnum];
}
